import BFLLink from "@repo/shared-ui/BFLLink";

const InvestNowConsentModal = () => {
  return (
    <div>
      <p className="text-center text-sm leading-[16px] text-black">
        To provide you with the best trading solutions, we are sharing your name and mobile number
        with Bajaj Financial Securities Limited. This will help you log in instantly.
      </p>

      <div className="bg-gray-150 mt-4 w-full space-y-2 rounded-md p-3">
        <p className="text-link-secondary">Note:</p>
        <ul className="text-link-secondary list-inside list-disc space-y-1 text-sm">
          <li className="mb-2">
            The usage of your information is governed basis the terms and conditions{" "}
            <BFLLink
              href="//cms-assets.bajajfinserv.in/is/content/bajajfinance/BFSL_Terms_Conditionspdf-1"
              openInNewTab={true}
              className="text-blue-600 underline hover:text-blue-800"
            >
              (T&C)
            </BFLLink>{" "}
            of Bajaj Financial Securities Limited.
          </li>
          <li className="mb-2">
            Bajaj Financial Securities Limited will share your relationship and transaction details
            with Bajaj Finance Limited for displaying such details on web portal/mobile application
            of BFL.
          </li>
          <li className="mb-2">
            You can revoke your consent on our app or website by going to the Help & Support
            section, once you've completed any required agreements for the product or service (if
            availed any).
          </li>
        </ul>
      </div>

      <p className="mt-4 text-center text-sm text-black">
        Click on CONTINUE to share your details for auto login. If you choose to skip it, you will
        be asked to log in by entering your credentials on Bajaj Financial Securities Limited.
      </p>
    </div>
  );
};

export default InvestNowConsentModal;
